<div class="app_wrapper" *ngIf="app_data != undefined">
  <h1>{{ app_data.name }}</h1>
  <h3>
    {{ current_lang === "de" ? app_data.subtext_de : app_data.subtext_en }}
  </h3>

  <img src="{{ app_data.image_url }}" alt="" />
  <hr />
  <a href="{{ app_data.app_url }}" target="blank">
    <button>
      {{ i18n.app.download }}
    </button>
  </a>
  <hr />
  <div class="box">
    <h3>{{ current_lang === "de" ? "Beschreibung" : "Description" }}</h3>
    <p
      innerHtml="{{
        current_lang === 'de' ? app_data.descr_de : app_data.descr_en
      }}"
    ></p>
  </div>
</div>
